export const pushToDataLayer = (data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(data);
};


export const trackPageView = (location) => {
  pushToDataLayer({
    event: 'page_view',
    page_path: location.pathname + location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
};


export const trackViewItem = (product, variant, lang = "EN") => {
  if (!product || !variant) return;

  const getName = (item) => {
    if (!item) return "";
    return lang === "AR" && item.nameAr ? item.nameAr : item.nameEn;
  };

  const price = variant.discountPrice || variant.price || 0;

  window.dataLayer = window.dataLayer || [];

  window.dataLayer.push({
    event: "view_item",

    ecommerce: {
      currency: "EGP",
      value: Number(price),

      items: [
        {
          item_id: String(product.id),
          item_name: getName(product),

          item_brand: getName(product.brand),

          item_category: getName(product.collection),
          item_category2: getName(product.category),
          item_category3: getName(product.subCategory),

          // item_variant: String(variant.id),
          item_variant: `${getName(variant.color)} / ${getName(variant.size)}`,

          price: Number(price),
          quantity: 1,
        },
      ],
    },
  });
};